/* eslint-disable */
import 'isomorphic-fetch'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_ROOT, USER_ALREADY_LOGGED_IN } from '../../constants/constants'

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: fetchBaseQuery({
    baseUrl: API_ROOT,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  }),
  tagTypes: ['WhitelistedDomains', 'isUserLoggedIn'],
  endpoints: (builder) => ({
    isUserLoggedIn: builder.query({
      query: () => ({
        url: `/session/info`,
        method: 'GET'
      }),
      transformResponse: (response: any) =>
        response.data === USER_ALREADY_LOGGED_IN,
      providesTags: ['isUserLoggedIn']
    }),
    getWhitelistedDomains: builder.query({
      query: () => ({
        url: `/whitelisteddomain`,
        method: 'GET'
      }),
      transformResponse: (response: any) =>
        response.data.allowed_domains.split(','),
      providesTags: ['WhitelistedDomains']
    }),
    validateUserEmail: builder.query({
      query: (email: string) => ({
        url: `/user/profile/${encodeURIComponent(email)}`,
        method: 'GET'
      }),
      transformResponse: (response: any) => response.data,
      providesTags: []
    }),
    sendLostPasswordEmail: builder.mutation({
      query: (email: string) => ({
        url: `/user/forgot-password/${encodeURIComponent(email)}`,
        method: 'POST',
        body: { search: window.location.search }
      }),
      transformResponse: (response: any) => response.data
    }),
    sendForgotUsernameEmail: builder.mutation({
      query: (email: string) => ({
        url: `/user/forgot-username/${encodeURIComponent(email)}`,
        method: 'POST',
        body: { search: window.location.search }
      }),
      transformResponse: (response: any) => response.data
    }),
    changePassword: builder.mutation({
      query: ({ password, recoveryToken }) => ({
        url: '/reset-password-with-token',
        method: 'POST',
        body: { newPassword: password, recoveryToken }
      }),
      transformResponse: (response: any) => response.data,
      invalidatesTags: []
    }),
    forceChangePassword: builder.query({
      query: ({ login, oldPassword, newPassword }) => ({
        url: '/reset-password-with-token',
        method: 'PUT',
        body: {
          login,
          old_password: oldPassword,
          new_password: newPassword
        }
      }),
      transformResponse: (response: any) => response.data,
      providesTags: []
    }),
    validateRecoveryToken: builder.mutation({
      query: (recoveryToken: string) => ({
        url: '/token-validation',
        method: 'POST',
        body: { recoveryToken }
      }),
      transformResponse: (response: any) => response.data,
      invalidatesTags: []
    }),
    sendAccountActivationEmail: builder.query({
      query: (email: string) => ({
        url: `/user/resend-activation/${encodeURIComponent(email)}`,
        method: 'POST',
        body: {}
      }),
      transformResponse: (response: any) => response.data,
      providesTags: []
    }),
    deleteSSOId: builder.mutation({
      query: ({ ssosid, myaccountSid }) => ({
        url: `/session/${ssosid || null})/${myaccountSid || null}`,
        method: 'DELETE'
      }),
      transformResponse: (response: any) => response.data
    })
  })
})

export const {
  useIsUserLoggedInQuery,
  useChangePasswordMutation,
  useDeleteSSOIdMutation,
  useForceChangePasswordQuery,
  useGetWhitelistedDomainsQuery,
  useSendAccountActivationEmailQuery,
  useSendForgotUsernameEmailMutation,
  useValidateRecoveryTokenMutation,
  useValidateUserEmailQuery,
  useSendLostPasswordEmailMutation
} = adminApi
